import Header from "../components/Header";
import SeoHead from "../components/SeoHead";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Intro from "../components/Intro";
import Phrases from "../components/Phrases";
import Features from "../components/Features";
import Videos from "../components/Videos";
import LanguagesSection from "../components/LanguagesSection";
import DownloadCTA from "../components/DownloadCTA";
import Footer from "../components/Footer";

const LandingPage = () => (
  <div className="min-h-screen bg-[#FAFAF9] text-slate-900" data-testid="landing-page">
    <SeoHead page="home" />
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Intro />
      <Phrases />
      <Features />
      <Videos />
      <LanguagesSection />
      <DownloadCTA />
    </main>
    <Footer />
  </div>
);

export default LandingPage;
